import { ref } from 'vue'
import { reportError } from '../utils/reporting'

export function useHelpCenterFetch(pathFn, { select } = {}) {
  const data = ref(null)
  const loading = ref(false)
  const error = ref(false)
  const apiUrl = import.meta.env.VITE_API_URL

  let inflight = null

  const load = async () => {
    if (inflight) inflight.abort()
    const controller = new AbortController()
    inflight = controller

    loading.value = true
    error.value = false
    try {
      const response = await fetch(apiUrl + pathFn(), { signal: controller.signal })
      if (!response.ok) {
        throw new Error(`fetch failed: ${response.status} ${response.statusText}`)
      }
      const body = await response.json()
      if (!body.isSuccess) {
        throw new Error('helpcenter: isSuccess=false')
      }
      data.value = select ? select(body.answer) : body.answer
    } catch (err) {
      if (err.name === 'AbortError') return
      reportError(err, { source: 'useHelpCenterFetch', path: pathFn() })
      error.value = true
      data.value = null
    } finally {
      if (inflight === controller) {
        loading.value = false
        inflight = null
      }
    }
  }

  return { data, loading, error, load }
}
